import type { ComponentProps, ReactNode } from 'react'

import { useSafetyTranslation } from 'cng-common/features/translations'
import type { IModalContent } from 'core-components/library/modalDialog'
import { CockpitCardHeader } from 'partner360/features/financialCockpit/ui/components/cockpitCardHeader'
import { CockpitIconButton } from 'partner360/features/financialCockpit/ui/components/cockpitIconButton'
import { PLAN_SECTION_DIALOG_TRANSLATION_KEYS } from 'partner360/features/planSectionDialog/translations'

import { PlanReviewDialogContent } from './PlanReviewDialogContent'

import styles from './PlanReviewModalContent.module.scss'

interface IPlanReviewModalContentProps extends IModalContent {
  title: ReactNode
  description: string
  sectionUrl: string | null
  sectionLinkLabel: string
  reviewProps: Omit<ComponentProps<typeof PlanReviewDialogContent>, 'closeModal'>
}

/** Only the modal's header changes: closing still goes through ModalDialog's own closeModal. */
export const PlanReviewModalContent = ({
  title,
  description,
  sectionUrl,
  sectionLinkLabel,
  reviewProps,
  closeModal,
}: IPlanReviewModalContentProps) => {
  const t = useSafetyTranslation()

  return (
    <div className={styles.root}>
      <header className={styles.header}>
        <CockpitCardHeader
          title={<span className={styles.text}>{title}</span>}
          description={
            <span className={styles.text} title={description}>
              {description}
            </span>
          }
          actions={
            <>
              {sectionUrl && (
                <CockpitIconButton
                  showLabel
                  icon="kbase kbase-external-link"
                  label={sectionLinkLabel}
                  href={sectionUrl}
                  target="_blank"
                />
              )}
              <CockpitIconButton
                icon="kbase kbase-close"
                label={t(PLAN_SECTION_DIALOG_TRANSLATION_KEYS.close, { defaultValue: 'Close' })}
                onClick={closeModal}
              />
            </>
          }
        />
      </header>
      <PlanReviewDialogContent {...reviewProps} closeModal={closeModal} />
    </div>
  )
}
